const profile = {
  avatar: "./imgs/profile/cartoon.png",
  name: "Chunshi Wang",
  email: "c.s.wang@foxmail.com",
  social: {
    github: "https://github.com/AiEson",
    googleScholar: "https://scholar.google.com/citations?user=LNxEN9cAAAAJ"
  },
  education: [
    {
      period: "September 2025 - Present",
      institution: "Zhejiang University",
      degree: "Master"
    },
    {
      period: "June 2025 - Present",
      institution: "{fig:./imgs/profile/Tencent_Logo.svg}Hunyuan3D",
      degree: "Research Intern, working closely with [Liu Jian](https://hitcslj.github.io/), supervised by [Li Yang](https://yang-l1.github.io/)"
    },
    {
      period: "September 2021 - June 2025",
      institution: "Guilin University of Electronic Technology",
      degree: "Bachelor"
    }
  ],
  researchInterests: [
    "3D Vision", 
    "3D Generation", 
    "Interactive Audio Generation", 
    "Semi-supervised Learning"
  ]
};

export default profile;
